<app-protected-content [requiredRoles]="requiredRoles">
<div class="container" *transloco="let t; prefix: 'dsaManagement.users'">
  <htx-button variant="tertiary" icon="arrow_back" (click)="cancel()">{{ 'button.back' | transloco }}</htx-button>

  <div class="panel">
    <div class="edit-header">
      <div class="header-title-section">
        <h1 class="header-title">{{ t('edit.header') }}</h1>
        <p class="header-subtitle">{{ t('edit.subtitle') }}</p>
      </div>
      <htx-button
        variant="primary"
        icon="save"
        (click)="save()"
        [disabled]="form.invalid || saving"
      >
        {{ t('edit.submit') }}
      </htx-button>
    </div>

    <div class="form-sections">
      <htx-form-section
        [title]="t('form.title')"
        [icon]="'person'"
        [formGroup]="form"
        [controlNames]="['firstName', 'lastName', 'email']"
        [fieldLabels]="fieldLabels"
      >
        <htx-text-field-with-error
          [ctrl]="form.controls.firstName"
          [label]="t('form.firstName')"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>

        <htx-text-field-with-error
          [ctrl]="form.controls.lastName"
          [label]="t('form.lastName')"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>

        <htx-text-field-with-error
          [ctrl]="form.controls.email"
          [label]="t('form.email')"
          type="email"
          [errorMessages]="errorMessagesService.messages()"
        >
        </htx-text-field-with-error>
      </htx-form-section>
    </div>
  </div>
</div>
</app-protected-content>
